export const SHOPPING_CART_SET_TOKEN = 'SHOPPING_CART_SET_TOKEN';
